import ExternalContentPage from './ExternalContentPage';

export default ExternalContentPage;
